<template>
  <router-view/>
</template>

<script setup>
</script>

<style lang="scss">
@import '~@/assets/css/common.scss'
</style>
